<template>
  <section>
    <p class="lead">エスコートは<strong>２タイプ</strong>×<strong>２グレード</strong><br>＋<strong>3つのパッケージ</strong>でラインアップ。</p>

    <div class="col">
      <div class="wtype">
        <div class="inner">
          <div>
            <p class="type"><span>W</span>type</p>
            <p class="desc">ウェイビー浴槽の曲線と<br>コーナーが生み出す<br>かつてない広さ</p>
          </div>
        </div>
      </div>

      <div class="btype">
        <div class="inner">
          <div>
            <p class="type"><span>B</span>type</p>
            <p class="desc">直線的でソリッドな<br>印象と広さを両立</p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'SlideType'
}
</script>

<style scoped lang="scss">
.lead {
  text-align: center;
  background: $colorLightGray;
  padding: 40px 0;
  font-size: 16px;
  line-height: 1.75;

  @include mq(tb) {
    padding: 24px 0;
  }

  strong {
    font-size: 18px;
    margin: 0 3px;
  }

  br {
    display: none;

    @include mq(tb) {
      display: block;
    }
  }
}

.col {
  display: flex;

  @include mq(tb) {
    display: block;
  }

  > div {
    width: 50%;
    height: 50vw;
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
    display: flex;
    justify-content: center;
    align-items: center;

    @include mq(tb) {
      width: 100vw;
      height: 100vw;
    }

    &.wtype {
      background-image: url('/images/bg_wtype.jpg');
    }

    &.btype {
      background-image: url('/images/bg_btype.jpg');
    }

    .inner {
      background: #fff;
      width: 25.5vw;
      height: 25.5vw;
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: center;
      opacity: 0.7;

      @include mq(tb) {
        width: 60vw;
        height: 60vw;
      }
    }

    .type {
      font-family: $bellFont;
      font-size: 41px;

      @include mq(tb) {
        font-size: 30px;
      }

      span {
        font-size: 52px;

        @include mq(tb) {
          font-size: 38px;
        }
      }
    }

    .desc {
      font-size: 13px;
      font-weight: bold;
      line-height: 2;
      margin-top: 32px;

      @include mq(tb) {
        font-size: 11px;
        margin-top: 16px;
      }
    }
  }
}
</style>